var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCancelBenefit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.58625 7.9995L4.29325 5.7065C3.90225 5.3165 3.90225 4.6825 4.29325 4.2925C4.68325 3.9025 5.31725 3.9025 5.70725 4.2925L8.00025 6.5855L10.2933 4.2925C10.6832 3.9025 11.3173 3.9025 11.7073 4.2925C12.0972 4.6825 12.0972 5.3165 11.7073 5.7065L9.41425 7.9995L11.7073 10.2925C12.0972 10.6825 12.0972 11.3165 11.7073 11.7065C11.3173 12.0965 10.6832 12.0965 10.2933 11.7065L8.00025 9.4135L5.70725 11.7065C5.31725 12.0965 4.68325 12.0965 4.29325 11.7065C3.90225 11.3165 3.90225 10.6825 4.29325 10.2925L6.58625 7.9995Z",
  fill: "#83848A"
})));
export { SvgCancelBenefit as ReactComponent };